<input #_fileInput type="file" (change)="openCropperDialog($event)" accept="image/*" hidden>

<button ly-button color="primary" (click)="_fileInput.click()">
  <ly-icon [lyMf]="1">image</ly-icon>
  <span>Select File</span>
</button>

<div *ngIf="cropped"><img [src]="cropped"></div>

<ly-slider [ngClass]="classes.slider" [value]="76"></ly-slider>
<ly-slider [ngClass]="classes.slider" [value]="[11, 50]" [color]="'primary'"></ly-slider>
